import Model, { attr, hasMany, type HasMany } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';
import { createLocalizedProxy, type CustomTranslations } from 'invite-sign/utils/translations';

import type QuestionnaireSection from './questionnaire-section';

const TRANSLATABLE_ATTRIBUTE_MAPPING = {
  title: 'title',
} as const;
type TranslatableAttribute = keyof typeof TRANSLATABLE_ATTRIBUTE_MAPPING;

export default class Questionnaire extends Model {
  declare [Type]: 'questionnaire';

  @hasMany('questionnaire-section', { async: false, inverse: 'questionnaire' })
  declare questionnaireSections: HasMany<QuestionnaireSection>;

  @attr() declare customTranslations: CustomTranslations<TranslatableAttribute>;
  @attr('string') declare title: string;

  forLocale(locale: string, defaultLocale: string): this {
    if (locale !== defaultLocale) {
      return createLocalizedProxy(this, TRANSLATABLE_ATTRIBUTE_MAPPING, locale);
    }
    return this;
  }
}
